import dhtmlXCombo from './dhtmlXCombo';
import {dhx4} from "../../global/dhx4OrDhx";


dhtmlXCombo.prototype.setName = function (a) {
    this.conf.form_name = a;
    this.base.childNodes[1].name = a;
    this.base.childNodes[2].name = a.replace(/(\[.*)?$/, "_new_value$1");
};
dhtmlXCombo.prototype.readonly = function (a) {
    if (dhx4.s2b(a)) {
        this.base.firstChild.setAttribute("readOnly", "true");
        this.conf.ro_mode = true;
    } else {
        this.base.firstChild.removeAttribute("readOnly");
        this.conf.ro_mode = false;
    }
};
dhtmlXCombo.prototype.setPlaceholder = function (a) {
    if (typeof (a) == "undefined" || a == null) {
        a = "";
    }
    this.base.firstChild.setAttribute("placeholder", String(a));
};
dhtmlXCombo.prototype.setTemplate = function (e) {
    for (var c in e) {
        if (typeof (this.conf.template[c]) != "undefined") {
            if (c == "header") {
                this.conf.template[c] = dhx4.s2b(e[c]);
            } else {
                this.conf.template[c] = String(e[c]);
            }
        }
    }
    if (e.columns != null) {
        this._mcMakeTemplate(e.columns);
    } else {
        this._mcDetachHeader();
    }
    for (var c in this.t) {
        this.t[c].obj.setText(this.t[c].item, this.t[c].item._conf.text)
    }
    this._confirmSelect();
};
dhtmlXCombo.prototype.setSkin = function (a) {
    if (a == this.conf.skin) {
        return;
    }
    this.conf.skin = a;
    this.base.className = "dhxcombo_" + this.conf.skin + (this.conf.enabled ? "" : " dhxcombo_disabled");
    this.list.className = "dhxcombolist_" + this.conf.skin + (this.hdr != null ? " dhxcombolist_multicolumn" : "");
    if (this.hdr != null) {
        this.hdr.className = "dhxcombolist_" + this.conf.skin + " dhxcombolist_hdr";
    }
    this.conf.i_ofs = (a == "material" ? 26 : 23);
    this._adjustBase();
};
dhtmlXCombo.prototype.getInput = function () {
    return this.base.firstChild;
};
dhtmlXCombo.prototype.getButton = function () {
    return this.base.childNodes[this.base.childNodes.length - (this.conf.combo_image ? 2 : 1)];
};
dhtmlXCombo.prototype.getList = function () {
    return this.list;
};
dhtmlXCombo.prototype.getBase = function () {
    return this.base;
};
dhtmlXCombo.prototype.getParent = function () {
    return this.DOMParent;
};
dhtmlXCombo.prototype.forEachOption = function (a) {
    for (var c = 0; c < this.list.childNodes.length; c++) {
        a.apply(window, [this._getOption(this.list.childNodes[c]._optId, c)]);
    }
};
dhtmlXCombo.prototype.setFocus = function () {
    if (this.conf.enabled) {
        this.base.firstChild.focus();
    }
};
dhtmlXCombo.prototype.setFontSize = function (a, c) {
    if (a != null) {
        this.base.firstChild.style.fontSize = a;
    }
    if (c != null) {
        this.list.style.fontSize = c;
    }
};
dhtmlXCombo.prototype.getOption = function (h) {
    var l = null;
    var e = null;
    for (var g = 0; g < this.list.childNodes.length; g++) {
        if (l == null) {
            var c = this.list.childNodes[g]._optId;
            if (this.t[c].obj.getValue(this.t[c].item) == h) {
                l = c;
                e = g;
            }
        }
    }
    return (l == null ? null : this._getOption(l, e));
};
dhtmlXCombo.prototype.getOptionByIndex = function (a) {
    if (a < 0) {
        return null;
    }
    if (this.list.childNodes[a] == null) {
        return null;
    }
    return this._getOption(this.list.childNodes[a]._optId, a);
};
dhtmlXCombo.prototype.getOptionByLabel = function (h) {
    var l = null;
    var e = null;
    for (var g = 0; g < this.list.childNodes.length; g++) {
        if (l == null) {
            var c = this.list.childNodes[g]._optId;
            if (this.t[c].obj.getText(this.t[c].item, true) == h) {
                l = c;
                e = g;
            }
        }
    }
    return (l == null ? null : this._getOption(l, e));
};
dhtmlXCombo.prototype.getSelectedIndex = function () {
    return this._getOptionProp(this.conf.last_selected, "index", -1);
};
dhtmlXCombo.prototype.getSelectedText = function () {
    return this._getOptionProp(this.conf.last_selected, "text", "");
};
dhtmlXCombo.prototype.getSelectedValue = function () {
    return this._getOptionProp(this.conf.temp_selected || this.conf.last_selected, "value", null);
};
dhtmlXCombo.prototype.getActualValue = function () {
    return this.base.childNodes[1].value;
};
dhtmlXCombo.prototype.getComboText = function () {
    return this.base.childNodes[0].value;
};
dhtmlXCombo.prototype.getIndexByValue = function (c) {
    var a = this.getOption(c);
    return (a != null ? a.index : -1);
};
dhtmlXCombo.prototype.setComboText = function (a) {
    if (this.conf.allow_free_text != true) {
        return;
    }
    this.unSelectOption();
    this.conf.last_text = this.base.firstChild.value = a;
    this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
};
dhtmlXCombo.prototype.setComboValue = function (c) {
    var a = this.getOption(c);
    if (a != null) {
        this.selectOption(a.index);
    } else {
        this.conf.last_value = c;
        this.base.childNodes[1].value = this.conf.last_value;
        this.base.childNodes[2].value = "true";
    }
};
dhtmlXCombo.prototype.selectOption = function (c, e, a) {
    if (c < 0 || c >= this.list.childNodes.length) {
        return;
    }
    var g = this.list.childNodes[c]._optId;
    this._setSelected(g, this._isListVisible(), true);
    this._confirmSelect("script");
};
dhtmlXCombo.prototype.unSelectOption = function () {
    if (this.conf.last_hover != null) {
        this.t[this.conf.last_hover].obj.setSelected(this.t[this.conf.last_hover].item, false);
        this.conf.last_hover = null;
    }
    this.base.firstChild.value = "";
    if (this.conf.f_mode != false) {
        this._filterOpts(true);
    }
    this._hideList();
    this._updateTopImage(null);
    this._confirmSelect("script");
};
dhtmlXCombo.prototype.confirmValue = function () {
    this._confirmSelect("script");
};
dhtmlXCombo.prototype.enable = function (a) {
    a = (typeof (a) == "undefined" ? true : dhx4.s2b(a));
    if (this.conf.enabled == a) {
        return;
    }
    this.conf.enabled = a;
    if (a) {
        this.base.className = "dhxcombo_" + this.conf.skin;
        this.base.firstChild.removeAttribute("disabled");
    } else {
        this._hideList();
        this.base.className = "dhxcombo_" + this.conf.skin + " dhxcombo_disabled";
        this.base.firstChild.setAttribute("disabled", "true");
    }
    this._updateTopImage(this.conf.last_selected);
};
dhtmlXCombo.prototype.disable = function (a) {
    a = (typeof (a) == "undefined" ? true : dhx4.s2b(a));
    this.enable(!a);
};
dhtmlXCombo.prototype.isEnabled = function () {
    return (this.conf.enabled == true);
};
dhtmlXCombo.prototype.show = function (a) {
    if (typeof (a) == "undefined") {
        a = true;
    } else {
        a = dhx4.s2b(a);
    }
    this.base.style.display = (a == true ? "" : "none");
};
dhtmlXCombo.prototype.hide = function (a) {
    if (typeof (a) == "undefined") {
        a = true;
    }
    this.show(!a);
};
dhtmlXCombo.prototype.isVisible = function () {
    return (this.base.style.display == "");
};
dhtmlXCombo.prototype.setFilterHandler = function (a) {
    if (typeof (a) == "function") {
        this.conf.f_func = a;
        this.conf.f_mode = true;
        this.conf.f_dyn = this.conf.f_cache = this.conf.f_url = null;
    } else {
        if (typeof (a) == "string" && typeof (window[a]) == "function") {
            this.conf.f_func = window[a];
            this.conf.f_mode = true;
            this.conf.f_dyn = this.conf.f_cache = this.conf.f_url = null;
        } else {
            this.conf.f_func = null;
        }
    }
};
dhtmlXCombo.prototype.enableFilteringMode = function (g, c, a, e) {
    if (g == true || g == "between") {
        this.conf.f_mode = (g == true ? "start" : "between");
        if (c != null) {
            this.conf.f_url = c;
            this.conf.f_cache = dhx4.s2b(a);
            this.conf.f_dyn = dhx4.s2b(e);
        } else {
            this.conf.f_url = null;
            this.conf.f_cache = false;
            this.conf.f_dyn = false;
        }
    } else {
        this.conf.f_mode = false;
        this.conf.f_url = null;
        this.conf.f_cache = false;
        this.conf.f_dyn = false;
    }
};
dhtmlXCombo.prototype.filter = function (e, a) {
    for (var g = 0; g < this.list.childNodes.length; g++) {
        var c = e.apply(window, [this._getOption(this.list.childNodes[g]._optId, g)]);
        this.list.childNodes[g].style.display = (c === true ? "" : "none");
    }
    if (typeof (a) == "undefined" || a == true) {
        this._showList(true);
    }
};
dhtmlXCombo.prototype.sort = function (e) {
    var a = [];
    for (var c = 0; c < this.list.childNodes.length; c++) {
        var g = this.list.childNodes[c]._optId;
        a.push([g, this._getOption(g, c)]);
    }
    if (e == "asc" || e == "desc") {
        var k = true;
        a.sort(function (l, h) {
            l = l[1].text_option.toLowerCase();
            h = h[1].text_option.toLowerCase();
            var m = (e == "asc" ? 1 : -1);
            return (l > h ? m : -1 * m);
        });
    } else {
        if (typeof (e) == "function" || typeof (window[e]) == "function") {
            if (typeof (window[e]) == "function") {
                e = window[e];
            }
            a.sort(function (l, h) {
                return e.apply(window, [l[1], h[1]]);
            });
        }
    }
    while (this.list.childNodes.length > 0) {
        this.list.removeChild(this.list.lastChild);
    }
    for (var c1 = 0; c1 < a.length; c1++) {
        this.list.appendChild(this.t[a[c1][0]].item);
    }
};
dhtmlXCombo.prototype.enableAutocomplete = function (a) {
    if (typeof (a) == "undefined") {
        a = true;
    } else {
        a = dhx4.s2b(a);
    }
    this.conf.f_ac = a;
};
dhtmlXCombo.prototype.disableAutocomplete = function (a) {
    if (typeof (a) == "undefined") {
        a = true;
    } else {
        a = dhx4.s2b(a);
    }
    this.enableAutocomplete(!a);
};

dhtmlXCombo.prototype.allowFreeText = function (c, a) {
    this.conf.allow_free_text = (typeof (c) == "undefined" ? true : dhx4.s2b(c));
    this.conf.free_text_empty = (typeof (a) == "undefined" ? false : dhx4.s2b(a));
};
dhtmlXCombo.prototype._checkForMatch = function (g) {
    var a = dhx4.trim(this.base.firstChild.value).toLowerCase();
    var h = null;
    var c = this.list.firstChild;
    while (c != null) {
        if (c.style.display == "" && c._optId != null) {
            var e = dhx4.trim(this.t[c._optId].obj.getText(c, true)).toLowerCase();
            if (a == e) {
                h = c._optId;
                c = null;
            }
        }
        if (c != null) {
            c = c.nextSibling;
        }
    }
    if (this.conf.last_match == null) {
        if (h != null) {
            this._setSelected(h, true, true);
            this.conf.last_match = h;
        } else {
            if (this.conf.f_mode != "between" || g == true) {
                this._setSelected(null, true, true);
                this.conf.last_match = null;
            }
        }
    } else {
        if (h != null) {
            if (h != this.conf.last_match) {
                this._setSelected(h, true, true);
                this.conf.last_match = h;
            }
        } else {
            this._setSelected(null, true, true);
            this.conf.last_match = null;
        }
    }
};
dhtmlXCombo.prototype._selectRange = function (c, a) {
    if (this.conf.combo_focus == true) {
        dhx4.selectTextRange(this.base.firstChild, c, a);
    }
};
dhtmlXCombo.prototype.openSelect = function () {
    if (!this._isListVisible()) {
        this._showList();
    }
};
dhtmlXCombo.prototype.closeAll = function () {
    this._hideList();
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCombo/dhtmlXComboMethod0.js